(function(){

const STORAGE_KEY = 'comet_recent_history';

const inputs = document.querySelectorAll(
'#Search-In-Modal,#Search-In-Template,.search-modal__input'
);

if(!inputs.length) return;

const initialStates = document.querySelectorAll('#search-initial-state');

const predictiveResults = document.querySelectorAll(
'.predictive-search, .predictive-search--search-template'
);


/* -----------------------------
RENDER RECENT SEARCH HISTORY
----------------------------- */

function renderHistory(){

const containers = document.querySelectorAll('.recent-searches-container');
const lists = document.querySelectorAll('.recent-searches-list');
const template = document.querySelector('#recent-item-template');

if(!template) return;

const history = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');

containers.forEach(container=>{
if(history.length === 0){
container.classList.add('hidden');
}else{
container.classList.remove('hidden');
}
});

lists.forEach(list=>{

list.innerHTML = '';

history.forEach(term=>{

const clone = template.content.cloneNode(true);

clone.querySelector('.recent-search-link').href =
`/search?q=${encodeURIComponent(term)}`;

clone.querySelector('.recent-text').textContent = term;

clone.querySelector('.delete-single-item').onclick = function(e){

e.preventDefault();
e.stopPropagation();

let newHistory = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]')
.filter(t => t !== term);

localStorage.setItem(STORAGE_KEY, JSON.stringify(newHistory));

renderHistory();

};

list.appendChild(clone);

});

});

}


/* -----------------------------
INPUT CHECK
----------------------------- */

function checkInput(input){

const val = input.value.trim();

if(val.length === 0){

initialStates.forEach(el=>el.style.display = 'block');

predictiveResults.forEach(el=>{
el.style.setProperty('display','none','important');
});

renderHistory();

}else{

initialStates.forEach(el=>el.style.display = 'none');

predictiveResults.forEach(el=>{
el.style.removeProperty('display');
});

}

}


/* -----------------------------
INPUT EVENTS
----------------------------- */

inputs.forEach(input=>{

input.addEventListener('focus',()=>checkInput(input));

input.addEventListener('input',()=>checkInput(input));

const form = input.closest('form');

if(form){

form.addEventListener('submit',()=>{

const term = input.value.trim();

if(term.length > 1){

let history = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');

history = [term, ...history.filter(t=>t !== term)].slice(0,5);

localStorage.setItem(STORAGE_KEY, JSON.stringify(history));

}

});

}

});


/* -----------------------------
CLEAR ALL RECENT SEARCHES
----------------------------- */

document.addEventListener('click', function(e){

const clearBtn = e.target.closest('.clear-recent-searches');

if(!clearBtn) return;

e.preventDefault();
e.stopPropagation();
e.stopImmediatePropagation();

localStorage.removeItem(STORAGE_KEY);

renderHistory();

document
.querySelectorAll('.recent-searches-container')
.forEach(el=>el.classList.add('hidden'));

return false;

}, true);


/* -----------------------------
CLICK OUTSIDE SEARCH AREA
----------------------------- */

document.addEventListener('click', function(e){

const searchAreas = document.querySelectorAll(
'.header__search,.template-search__search'
);

let clickedInside = false;

searchAreas.forEach(area=>{
if(area.contains(e.target)){
clickedInside = true;
}
});

if(!clickedInside){
initialStates.forEach(el=>el.style.display = 'none');
}

});


/* -----------------------------
FIX MOBILE FIRST CLICK
----------------------------- */

document.querySelectorAll('.header__search summary').forEach(summary=>{
summary.addEventListener('click',function(){
setTimeout(function(){
const input = document.querySelector('#Search-In-Modal, .search-modal__input');
if(input){
input.focus();
input.dispatchEvent(new Event('focus'));
}
},100);
});
});


})();